var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about",attrs:{"id":"about"}},[_c('img',{attrs:{"width":"120px","src":require('@/assets/images/logo_sas_portrait.svg')}}),_c('p',[_vm._v("Obrigado por usar nosso aplicativo.")]),_c('hr'),_c('p',[_vm._v("V0.7.0")])])}
var staticRenderFns = []

export { render, staticRenderFns }